import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref } from "vue";
import _imports_0 from '../assets/image_message_appear/reportNull.png';
const _hoisted_1 = {
  class: "voice-report-history"
};
const _hoisted_2 = {
  key: 0,
  class: "navbar"
};
const _hoisted_3 = {
  class: "filter-bar"
};
const _hoisted_4 = {
  class: "filter-row"
};
const _hoisted_5 = {
  class: "date-value"
};
const _hoisted_6 = {
  class: "date-value"
};
const _hoisted_7 = {
  key: 1,
  class: "list-wrapper"
};
const _hoisted_8 = {
  class: "list-inner",
  id: "voice_history_inner"
};
const _hoisted_9 = {
  class: "card-row-1"
};
const _hoisted_10 = {
  class: "event-tag"
};
const _hoisted_11 = {
  class: "tag-icon"
};
const _hoisted_12 = {
  class: "report-name"
};
const _hoisted_13 = {
  class: "card-row-2"
};
const _hoisted_14 = {
  class: "time-section"
};
const _hoisted_15 = {
  class: "time-text"
};
const _hoisted_16 = {
  class: "card-row-3"
};
const _hoisted_17 = {
  class: "card-thumb"
};
const _hoisted_18 = ["src", "onError"];
const _hoisted_19 = {
  key: 1,
  class: "thumb-placeholder"
};
const _hoisted_20 = {
  key: 0,
  class: "report-desc"
};
const _hoisted_21 = {
  class: "card-row-4"
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  key: 2,
  class: "loading-box"
};
const _hoisted_24 = {
  key: 3,
  class: "empty-box"
};
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Notify } from "@nutui/nutui";
import request from "@/utils/request";
import { aiVoiceInfoReportList } from "@/utils/api";
export default {
  __name: 'voiceReportHistory',
  setup(__props) {
    const store = useStore();
    const router = useRouter();
    const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

    // 判断当前是否在小程序 web-view 内（小程序里 wx.miniProgram 存在）
    const isInMiniProgram = typeof window !== 'undefined' && !!(window.wx && window.wx.miniProgram && typeof window.wx.miniProgram.navigateBack === 'function');

    // 仅 APP 原生环境（非 H5 小程序 web-view、且 easyearn 注入）下展示自绘 header
    // 约定与其他页面保持一致：小程序 web-view 用小程序自带导航栏；纯 H5 用浏览器头部
    const showAppHeader = computed(() => {
      if (isInMiniProgram) return false;
      // easyearn 宿主存在 → APP 环境
      return typeof window !== 'undefined' && !!window.easyearn;
    });

    // 返回按钮：APP 场景调用 easyearn.goBackToPage('input')，并做降级保护
    function goBack() {
      const ee = typeof window !== 'undefined' ? window.easyearn : null;
      if (ee) {
        try {
          if (typeof ee.goBackToPage === 'function') {
            // 必须传目标页面标识，APP 原生端会按该 key 定位原生录入页；
            // 缺省参数会导致宿主抛 "Method not found"（因为匹配不到目标路由）。
            ee.goBackToPage('input');
            return;
          }
          if (typeof ee.goBack === 'function') {
            ee.goBack();
            return;
          }
        } catch (err) {
          console.error('[voiceReportHistory] easyearn goBack 失败，降级 router.go(-1)', err);
        }
      }
      // 兜底：退回上一页
      router.go(-1);
    }

    /**
     * 从当前 URL（含 hash）解析 openId，用于在进入页面 / 跳转时兜底补齐。
     * 小程序 web-view 下 URL 是 h5webNoNav 拼接的，会带 &openId=xxx。
     */
    function pickOpenIdFromUrl() {
      try {
        const q = new URLSearchParams(window.location.search || '');
        const cand = q.get('openId') || q.get('openid') || q.get('opid') || '';
        if (cand) return cand;
        // 兼容 hash 里携带
        const h = window.location.hash || '';
        const i = h.indexOf('?');
        if (i > -1) {
          const hq = new URLSearchParams(h.slice(i + 1));
          return hq.get('openId') || hq.get('openid') || hq.get('opid') || '';
        }
      } catch (e) {/* ignore */}
      return '';
    }

    /**
     * 进入 history 页时立刻兜底写入 store.userOpenId，
     * 避免后续跳转到 confirm 页后 COS 上传无 openid 导致 403。
     */
    (function ensureOpenIdOnEnter() {
      if (store.state.userOpenId) return;
      const openId = pickOpenIdFromUrl();
      if (openId) {
        store.commit('setuserOpenId', openId);
        try {
          localStorage.setItem('userOpenId', openId);
        } catch (e) {/* ignore */}
        console.log('[voiceReportHistory] ensureOpenIdOnEnter 写入:', openId);
      }
    })();

    // 事件类型映射（与 voiceReportConfirm.vue 保持一致）
    const EVENT_TYPE_OPTIONS = [{
      label: '事故处置',
      emoji: '🚗',
      aliases: ['事故']
    }, {
      label: '占路施工',
      emoji: '🚧',
      aliases: ['施工', '道路施工', '占道施工']
    }, {
      label: '天气预警',
      emoji: '⚠️',
      aliases: ['天气', '暴雨', '积水', '结冰', '大雾', '团雾', '冰雪']
    }, {
      label: '通行阻碍',
      emoji: '🚙',
      aliases: ['拥堵', '路障', '障碍', '通行受阻', '阻碍']
    }, {
      label: '安全管控',
      emoji: '🚫',
      aliases: ['封路', '管控', '交通管制', '限行']
    }, {
      label: '其他',
      emoji: '🚧',
      aliases: []
    }];
    function getEventTypeConfig(eventTypeStr) {
      const text = eventTypeStr === undefined || eventTypeStr === null ? '' : String(eventTypeStr).trim();
      if (!text) return null;
      return EVENT_TYPE_OPTIONS.find(item => {
        if (text === item.label || text.includes(item.label)) return true;
        return item.aliases.some(alias => text === alias || text.includes(alias));
      }) || null;
    }
    function getEventTypeLabel(eventTypeStr) {
      var _getEventTypeConfig;
      return ((_getEventTypeConfig = getEventTypeConfig(eventTypeStr)) === null || _getEventTypeConfig === void 0 ? void 0 : _getEventTypeConfig.label) || eventTypeStr || '交通路况';
    }
    function getEventEmoji(eventTypeStr) {
      var _getEventTypeConfig2;
      return ((_getEventTypeConfig2 = getEventTypeConfig(eventTypeStr)) === null || _getEventTypeConfig2 === void 0 ? void 0 : _getEventTypeConfig2.emoji) || '🚧';
    }

    // 状态映射：20=草稿，40=正式提交，其他=未知
    const STATE_MAP = {
      20: '草稿',
      40: '正式提交'
    };

    // 筛选条件
    const startDate = ref('');
    const endDate = ref('');
    const showStartPicker = ref(false);
    const showEndPicker = ref(false);
    const startPickerValue = ref(new Date().toLocaleString());
    const endPickerValue = ref(new Date().toLocaleString());

    // 分页
    const page = ref(1);
    const hasMore = ref(false);
    const isLoading = ref(false);

    // 列表数据
    const historyList = ref([]);

    // 格式化日期为 YYYY-MM-DD
    function formatDate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    }

    // 格式化显示时间
    function formatDisplayTime(timeStr) {
      if (!timeStr) return '';
      const now = new Date();
      const target = new Date(timeStr.replace(/-/g, '/'));
      const todayStr = formatDate(now);
      const targetDateStr = formatDate(target);
      const hours = String(target.getHours()).padStart(2, '0');
      const minutes = String(target.getMinutes()).padStart(2, '0');
      if (todayStr === targetDateStr) {
        return `今天 ${hours}:${minutes}`;
      }
      const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);
      if (formatDate(yesterday) === targetDateStr) {
        return `昨天 ${hours}:${minutes}`;
      }
      return timeStr;
    }

    // 初始化默认日期（近30天）
    function initDefaultDates() {
      const now = new Date();
      endDate.value = formatDate(now);
      startDate.value = formatDate(new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000));
    }
    onMounted(() => {
      // 进入"上报历史"时清掉上一次编辑流程残留的 edit_mode 标记，
      // 避免 confirm 页 localStorage 兜底分支把查看模式误判为编辑模式。
      localStorage.removeItem('voice_report_edit_mode');
      initDefaultDates();
      fetchList(true);
    });

    // 开始日期确认
    function onStartDateConfirm(value) {
      showStartPicker.value = false;
      if (value) {
        const d = new Date(value);
        startDate.value = formatDate(d);
      }
    }

    // 结束日期确认
    function onEndDateConfirm(value) {
      showEndPicker.value = false;
      if (value) {
        const d = new Date(value);
        endDate.value = formatDate(d);
      }
    }

    // 重置
    function onReset() {
      initDefaultDates();
      page.value = 1;
      hasMore.value = false;
      historyList.value = [];
      fetchList(true);
      Notify.success('已重置');
    }

    // 搜索
    function onSearch() {
      if (!startDate.value || !endDate.value) {
        Notify.warn('请选择起止时间');
        return;
      }
      if (startDate.value > endDate.value) {
        Notify.warn('开始时间不能晚于结束时间');
        return;
      }
      page.value = 1;
      hasMore.value = false;
      historyList.value = [];
      fetchList(true);
    }

    // 加载更多
    function onLoadMore(done) {
      if (hasMore.value && !isLoading.value) {
        fetchList(false);
      }
      done && done();
    }

    // 请求列表
    async function fetchList(isRefresh) {
      if (isLoading.value) return;
      isLoading.value = true;
      try {
        const openId = store.state.userOpenId || '';
        const res = await request('post', aiVoiceInfoReportList, {
          common: {
            openid: openId,
            version: '110211',
            module_id: 1,
            vcode: '31000008'
          },
          startCreateTime: startDate.value,
          endCreateTime: endDate.value,
          page: page.value
        });
        if (res && res.code === 0 && res.data) {
          const list = (res.data.list || []).map(item => ({
            ...item,
            stateStr: STATE_MAP[item.state] || '未知',
            displayTime: formatDisplayTime(item.reportTime || item.createTime),
            thumbnail: ''
          }));
          if (isRefresh) {
            historyList.value = list;
          } else {
            historyList.value = [...historyList.value, ...list];
          }
          hasMore.value = list.length >= 10;
          page.value = page.value + 1;

          // 异步解析每条记录的 cosUrl，提取封面图
          const startIdx = isRefresh ? 0 : historyList.value.length - list.length;
          list.forEach((item, i) => {
            if (item.cosUrl) {
              loadCoverImage(startIdx + i, item.cosUrl);
            }
          });
          console.log('historyList.value', historyList.value);
          if (isRefresh && list.length === 0) {
            Notify.warn('暂无记录');
          }
        } else {
          Notify.warn((res === null || res === void 0 ? void 0 : res.msg) || '请求失败');
        }
      } catch (err) {
        console.error('fetchList error:', err);
        Notify.warn('网络异常，请重试');
      } finally {
        isLoading.value = false;
      }
    }

    // 从 cosUrl（COS JSON）异步加载封面图
    function loadCoverImage(index, cosUrl) {
      if (!window.getReadOnlyPresignedUrlApi) {
        console.warn('getReadOnlyPresignedUrlApi 未就绪');
        return;
      }
      // 历史数据中有 cosUrl 以 http:// 开头，真机（iOS ATS）和后端签名接口都要求 https，
      // 否则会返回 40404 "请确认是否配置bucket"。这里统一规范为 https://。
      const normalizeUrl = u => {
        if (!u) return u;
        if (/^http:\/\//i.test(u)) return u.replace(/^http:\/\//i, 'https://');
        if (!/^https?:\/\//i.test(u)) return `https://${u}`;
        return u;
      };
      const url = normalizeUrl(cosUrl);
      console.log('[COS排查][history] index=', index, ' 原始cosUrl=', cosUrl, ' 规范化url=', url);
      window.getReadOnlyPresignedUrlApi(url).then(signedUrl => {
        console.log('[COS排查][history] JSON签名成功 index=', index, ' signedUrl=', signedUrl);
        request('get', signedUrl).then(res => {
          // COS JSON 中 url 数组包含图片/视频列表，取第一张非视频图片作为封面
          if (res && res.url && Array.isArray(res.url) && res.url.length > 0) {
            const firstImage = res.url.find(item => item.src && !item.src.match(/\.(mp4|mov|avi|wmv|flv|webm)(\?|$)/i));
            // 找不到非视频图片时不强行用视频当封面，静默降级为占位符
            if (firstImage && firstImage.src) {
              const imgUrl = normalizeUrl(firstImage.src);
              console.log('[COS排查][history] 准备签名封面图 index=', index, ' imgUrl=', imgUrl);
              window.getReadOnlyPresignedUrlApi(imgUrl).then(imgSignedUrl => {
                if (historyList.value[index]) {
                  historyList.value[index].thumbnail = imgSignedUrl;
                }
              }).catch(err => console.warn('[COS排查][history] 获取图片签名 URL 失败', {
                index,
                imgUrl,
                err
              }));
            }
          }
        }).catch(err => console.warn('[COS排查][history] 下载 COS JSON 失败', {
          index,
          signedUrl,
          err
        }));
      }).catch(err => console.warn('[COS排查][history] 获取 COS JSON 签名 URL 失败', {
        index,
        url,
        err
      }));
    }

    // 图片加载失败 — 清空 thumbnail，降级为占位符
    function onImgError(e, item) {
      e.target.style.display = 'none';
      item.thumbnail = '';
    }

    // 查看详情
    function viewDetail(item) {
      localStorage.setItem('voice_report_data', JSON.stringify(item));
      // 草稿状态(state=20)以编辑模式打开，可继续编辑提交
      const editMode = item.state === 20 ? '1' : '0';
      // 清掉可能残留的 edit_mode 标记（上一次编辑 → 选点流程会写入该键，
      // 若未正常走完 goBack 清理，这里必须主动清除，否则 confirm 页的
      // isEditMode 兜底读 localStorage 时仍为 '1'，导致查看模式下也显示
      // "提交/保存草稿"按钮而不是"返回"按钮）
      localStorage.setItem('voice_report_edit_mode', editMode);
      // ★ 清掉残留的选点标志 ★
      // 上一次编辑 → 跳选点页后如果用户中途退出（没走完 restoreFromStorage 末尾的 removeItem），
      // picking 标志会残留在 localStorage。下次从历史页"查看详情"进入 confirm 页时，
      // onBeforeMount 检测到该标志会误判为"选点回跳"，跳过 initFormData，导致页面空白/无数据。
      localStorage.removeItem('voice_report_picking_location');
      localStorage.removeItem('voice_report_form_data');

      // 真机兼容：小程序 web-view 内 vue-router 的 query 在某些场景（二次加载/选点回跳）
      // 会丢失，导致 confirm 页 route.query.edit 为 undefined，又走 localStorage 兜底。
      // 这里额外在 hash 里显式带一份 mode 参数（hash 跨 web-view 重载更稳定），
      // confirm 页会从 window.location.hash 解析 mode 作为最终兜底。
      const modeHash = editMode === '1' ? 'edit' : 'view';
      // 透传 openId，避免 confirm 页再丢失身份导致 COS 上传 403。
      // 优先取 store，其次从当前 URL 再解析一次。
      const openIdForPass = store.state.userOpenId || pickOpenIdFromUrl() || '';
      const query = {
        edit: editMode,
        mode: modeHash
      };
      if (openIdForPass) query.openId = openIdForPass;
      router.push({
        path: '/voice_report_confirm',
        query,
        hash: `#mode=${modeHash}${openIdForPass ? `&openId=${openIdForPass}` : ''}`
      });
    }
    return (_ctx, _cache) => {
      const _component_nut_infiniteloading = _resolveComponent("nut-infiniteloading");
      const _component_nut_icon = _resolveComponent("nut-icon");
      const _component_t_date_time_picker = _resolveComponent("t-date-time-picker");
      const _component_t_popup = _resolveComponent("t-popup");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [showAppHeader.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
        class: "navbar-back",
        onClick: goBack
      }, [...(_cache[8] || (_cache[8] = [_createElementVNode("div", {
        class: "back-arrow"
      }, null, -1)]))]), _cache[9] || (_cache[9] = _createElementVNode("div", {
        class: "navbar-title"
      }, "上报历史", -1)), _cache[10] || (_cache[10] = _createElementVNode("div", {
        class: "navbar-placeholder"
      }, null, -1))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "date-picker",
        onClick: _cache[0] || (_cache[0] = $event => showStartPicker.value = true)
      }, [_cache[11] || (_cache[11] = _createElementVNode("span", {
        class: "date-label"
      }, "开始", -1)), _createElementVNode("span", _hoisted_5, _toDisplayString(startDate.value || '请选择'), 1)]), _cache[13] || (_cache[13] = _createElementVNode("span", {
        class: "date-separator"
      }, "至", -1)), _createElementVNode("div", {
        class: "date-picker",
        onClick: _cache[1] || (_cache[1] = $event => showEndPicker.value = true)
      }, [_cache[12] || (_cache[12] = _createElementVNode("span", {
        class: "date-label"
      }, "结束", -1)), _createElementVNode("span", _hoisted_6, _toDisplayString(endDate.value || '请选择'), 1)])]), _createElementVNode("div", {
        class: "filter-actions"
      }, [_createElementVNode("div", {
        class: "btn-reset",
        onClick: onReset
      }, "重置"), _createElementVNode("div", {
        class: "btn-search",
        onClick: onSearch
      }, "搜索")])]), historyList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_nut_infiniteloading, {
        "container-id": "voice_history_inner",
        "has-more": hasMore.value,
        "use-window": false,
        onLoadMore: onLoadMore,
        "use-capture": true,
        "load-more-txt": "",
        "load-icon": "loading"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyList.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "history-card",
            key: index
          }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(getEventEmoji(item.eventTypeStr)), 1), _createTextVNode(" " + _toDisplayString(getEventTypeLabel(item.eventTypeStr)), 1)]), _createElementVNode("span", _hoisted_12, _toDisplayString(item.reportName || '上报单'), 1)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, [_cache[14] || (_cache[14] = _createElementVNode("span", {
            class: "time-icon"
          }, "🕐", -1)), _createElementVNode("span", _hoisted_15, _toDisplayString(item.displayTime), 1), _cache[15] || (_cache[15] = _createElementVNode("span", {
            class: "dot-sep"
          }, "·", -1))]), _createElementVNode("span", {
            class: _normalizeClass(['status-tag', `status-tag-${item.state}`])
          }, _toDisplayString(item.stateStr), 3)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [item.thumbnail ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: item.thumbnail,
            alt: "",
            onError: $event => onImgError($event, item)
          }, null, 40, _hoisted_18)) : (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[16] || (_cache[16] = [_createElementVNode("span", null, "📷", -1)]))]))]), item.briefDescription ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(item.briefDescription), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("span", {
            class: "view-detail-btn",
            onClick: _withModifiers($event => viewDetail(item), ["stop"])
          }, "查看详情", 8, _hoisted_22)])]);
        }), 128))]),
        _: 1
      }, 8, ["has-more"])])])) : isLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_nut_icon, {
        name: "loading",
        size: "26px"
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[17] || (_cache[17] = [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1), _createElementVNode("p", null, "暂无上报记录", -1)]))])), _createVNode(_component_t_popup, {
        modelValue: showStartPicker.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => showStartPicker.value = $event),
        placement: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_t_date_time_picker, {
          modelValue: startPickerValue.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => startPickerValue.value = $event),
          class: _normalizeClass(_unref(store).state.isH5 ? isIOS ? 't_date_picker newcss' : 't_date_picker newcss5' : 't_date_picker'),
          mode: "date",
          title: "选择开始日期",
          format: "YYYY-MM-DD",
          onConfirm: onStartDateConfirm,
          onCancel: _cache[3] || (_cache[3] = $event => showStartPicker.value = false)
        }, null, 8, ["modelValue", "class"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_t_popup, {
        modelValue: showEndPicker.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => showEndPicker.value = $event),
        placement: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_t_date_time_picker, {
          modelValue: endPickerValue.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => endPickerValue.value = $event),
          class: _normalizeClass(_unref(store).state.isH5 ? isIOS ? 't_date_picker newcss' : 't_date_picker newcss5' : 't_date_picker'),
          mode: "date",
          title: "选择结束日期",
          format: "YYYY-MM-DD",
          onConfirm: onEndDateConfirm,
          onCancel: _cache[6] || (_cache[6] = $event => showEndPicker.value = false)
        }, null, 8, ["modelValue", "class"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};